import { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import SessionTimer from "./SessionTimer";
import { FaCopy } from "react-icons/fa6";
import { ToastContainer, toast } from "react-toastify";
import { AiOutlineLogout } from "react-icons/ai";

import { FaUserCircle } from "react-icons/fa";
import { clearAuthSession } from "../RequireAuth";

function Commonheader() {
    const username = sessionStorage.getItem("user_name");
    const userId = sessionStorage.getItem("user_id");
    console.log("yssssss", userId);

    const [progress, setProgress] = useState(100);

    const handleLogout = () => {
        // sessionStorage.clear();
        clearAuthSession();

        document.cookie.split(";").forEach(cookie => {
            document.cookie = cookie
                .replace(/^ +/, "")
                .replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
        });

        if ("caches" in window) {
            caches.keys().then(names => {
                names.forEach(name => caches.delete(name));
            });
        }

        window.history.pushState(null, "", window.location.href);
        window.onpopstate = () => window.history.go(1);
        window.location.replace("/");
    };
    const handleCopyUsername = () => {
        if (userId) {
            navigator.clipboard.writeText(userId);

            toast.success("User ID Copied Successfully", {
                theme: "colored",
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
            });

        }
    };

    useEffect(() => {
        if (progress <= 0) {
            clearAuthSession();
        }
    }, [])

    return (
        <header className="top-header">
            <div className="par-logopart">
                <img src="../images/chelogo.png" alt="" className="img-fluid" />

                <div className="paralogo-text">

                    <h4 className="mb-0">
                        Commissionerate of Higher Education
                    </h4>
                    <p className="mb-0"> Government of Andhra Pradesh</p>
                </div>

                {/* <img src="../images/rusa-logo.webp" alt="" className="img-fluid rusa-logo" /> */}
            </div>

            <div className="user-details">
                <div className="session-timer-container fancy-timer me-2">
                    {/* <div className="seesiontimeinfo">
                        <p className="mb-0">Session Time:</p>
                    </div> */}
                    <div className="timer-box">
                        {/* <span className="timer-icon">⏳</span> */}
                        <span className="timer-text">
                            <SessionTimer
                                onLogout={handleLogout}
                                onProgress={setProgress}
                            />
                        </span>

                    </div>
                </div>

                <div className="user-drop-down">

                    <Dropdown align="end">
                        <Dropdown.Toggle variant="success">
                            <FaUserCircle size={25} />  Welcome to {username}-({userId})
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={handleCopyUsername}>
                                {userId}
                                <FaCopy style={{ marginLeft: "8px", cursor: "pointer" }} />
                            </Dropdown.Item>


                            <Dropdown.Divider />

                            {/* Logout */}
                            <Dropdown.Item onClick={handleLogout}>
                                <AiOutlineLogout size={24} />  Logout
                            </Dropdown.Item>

                        </Dropdown.Menu>
                    </Dropdown>
                    <ToastContainer />

                </div>
            </div>
        </header>
    );
}

export default Commonheader;
